import { render, staticRenderFns } from "./MCDTarget.vue?vue&type=template&id=1c1a4a3a&scoped=true"
import script from "./MCDTarget.vue?vue&type=script&lang=js"
export * from "./MCDTarget.vue?vue&type=script&lang=js"
import style0 from "./MCDTarget.vue?vue&type=style&index=0&id=1c1a4a3a&prod&scoped=true&lang=css"
import style1 from "./MCDTarget.vue?vue&type=style&index=1&id=1c1a4a3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a4a3a",
  null
  
)

export default component.exports